import script from "./ContactFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFooter.vue?vue&type=script&setup=true&lang=js"

import "./ContactFooter.vue?vue&type=style&index=0&id=1ca79b16&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca79b16"]])

export default __exports__